import React, { Fragment } from 'react';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose, lifecycle } from 'recompose';

import withRouteParams from '@sp/client/utils/withRouteParams';
import NavBar from '@sp/client/components/NavBar';

import PlanDetailsHeader from '../../components/PlanDetailsHeader';
import CarsList from '../../components/CarsList';
import PartiesList from '../../components/PartiesList';
import CommonInfo from '../../components/CommonInfo';
import PlanCancellationDetails from '../../components/PlanCancellationDetails';

import * as actions from '../../actions';

import s from './styles.less';

const propTypes = {
  plan: PropTypes.shape({
    id: PropTypes.number,
    cancelled: PropTypes.bool,
    contractNumber: PropTypes.string,
    VRN: PropTypes.string,
  }).isRequired,
  cancelledAt: PropTypes.string,
};
const defaultProps = {
  cancelledAt: null,
};

const PlanDetails = ({ plan, cancelledAt }) => (
  <NavBar withPadding>
    {plan.id && (
      <Fragment>
        <div className={s.section}>
          <PlanDetailsHeader {...plan} cancelledAt={cancelledAt} />
        </div>
        {plan.cancelled && (
          <div className={s.section}>
            <h2 className={s.sectionTitle}>Cancellation details: </h2>
            <PlanCancellationDetails />
          </div>
        )}
        <div className={s.section}>
          <h2 className={s.sectionTitle}>Common info: </h2>
          <CommonInfo />
        </div>
        <div className={s.section}>
          <h2 className={s.sectionTitle}>Parties: </h2>
          <PartiesList />
        </div>
        <div className={s.section}>
          <h2 className={s.sectionTitle}>Cars: </h2>
          <CarsList />
        </div>
      </Fragment>
    )}
  </NavBar>
);

PlanDetails.propTypes = propTypes;
PlanDetails.defaultProps = defaultProps;

const mapStateToProps = ({
  admin: { planDetails, planCancellationDetails },
}) => ({
  plan: planDetails,
  cancelledAt: get(planCancellationDetails, 'cancelledAt', null),
});

export default compose(
  withRouteParams('route'),
  connect(
    mapStateToProps,
    {
      getPlanDetails: actions.getPlanDetails,
      cancelPlan: actions.cancelPlan,
    },
  ),
  lifecycle({
    componentDidMount() {
      const {
        getPlanDetails,
        route: { id },
      } = this.props;

      getPlanDetails(id);
    },
  }),
)(PlanDetails);
